<template>
  <div class="my_assets">
    <div class="top_bg"></div>
    <div class="content_box content_auto">
      <div class="title_content">
        <p class="jump">{{ $t('我的资产') }}</p>
      </div>
      <div class="asset_total">
        <p class="asset_tips">{{ $t('总资产折合') }}(BTC)</p>
        <div class="num_action">
          <div class="assets_num">
            {{ isHideAssetsData ? allAsset : '********' }}

            <img
              width="40"
              height="40"
              class="show_hide_assets"
              :src="isHideAssetsData ? eyesClose : eyesOpen"
              @click="showHideAssets"
            />
          </div>

          <div class="assets_action">
            <Button @click="$router.push('/transfer')">
              {{ $t('划转') }}
            </Button>
            <Button
              type="primary"
              @click="handleAction('recharge')"
              class="recharge-btn"
            >
              {{ $t('充币') }}
            </Button>
            <Button @click="handleAction('mentionmoney')">
              {{ $t('提币') }}
            </Button>
          </div>
        </div>
        <div class="unit">
          ≈{{ isHideAssetsData ? allAssetUSD : '********' }} USD
        </div>
        <div class="hide_little_coin">
          <div class="rectangle_box" @click="handleReverseZero()">
            <i v-if="isHideZeroBalance" class="el-icon-check ok_img"></i>
          </div>
          <p>{{ $t('隐藏零余额的币种') }}</p>
        </div>
      </div>
      <Tabs v-model="currentTab" :animated="false" class="tab-container">
        <TabPane :label="$t('币币账户')" name="tab1">
          <div class="tab-box">
            <div class="tab-box-title">{{ $t('币币账户资产折合') }}(BTC)</div>
            <div class="tab-box-btc">
              {{ isHideAssetsData ? tokenAsset : '********' }}
            </div>
            <div class="tab-box-cny">
              ≈{{ isHideAssetsData ? tokenAssetUSD : '********' }} USD
            </div>
          </div>
        </TabPane>
        <TabPane :label="$t('合约账户')" name="tab2">
          <div class="tab-box">
            <div class="tab-box-title">{{ $t('合约账户资产折合') }}(BTC)</div>
            <div class="tab-box-btc">
              {{ isHideAssetsData ? contractAsset : '********' }}
            </div>
            <div class="tab-box-cny">
              ≈{{ isHideAssetsData ? contractAssetUSD : '********' }} USD
            </div>
          </div>
        </TabPane>
      </Tabs>
      <table v-show="currentTab === 'tab1'">
        <thead>
          <th class="table1-th">{{ $t('币种') }}</th>
          <th class="table1-th">{{ $t('可用') }}</th>
          <th class="table1-th">{{ $t('冻结') }}</th>
          <th class="table1-th">{{ $t('锁仓') }}</th>
          <th class="table1-th">{{ $t('估值') }}（CNY）</th>
          <th class="table1-th">{{ $t('操作') }}</th>
        </thead>
        <tbody>
          <tr
            v-for="itemInfo in displayedCoinsTokenAssetList"
            :key="itemInfo.coinName"
          >
            <td>
              {{ itemInfo.coinName }}
            </td>
            <td>
              {{ isHideAssetsData ? itemInfo.amountUsable : '******' }}
            </td>
            <td>
              {{ isHideAssetsData ? itemInfo.amountFrozen : '******' }}
            </td>
            <td>
              {{ isHideAssetsData ? itemInfo.amountLocked : '******' }}
            </td>
            <td>
              {{ isHideAssetsData ? itemInfo.cny : '******' }}
            </td>
            <td>
              <el-button
                type="text"
                @click="handleAction('recharge', itemInfo)"
              >
                {{ $t('充币') }}
              </el-button>
              <el-button
                type="text"
                @click="handleAction('mentionmoney', itemInfo)"
              >
                {{ $t('提币') }}
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <table v-show="currentTab === 'tab2'">
        <thead>
          <th class="table1-th">{{ $t('币种') }}</th>
          <th class="table1-th">{{ $t('可用') }}</th>
          <th class="table1-th">{{ $t('冻结') }}</th>
          <th class="table1-th">{{ $t('合计') }}</th>
          <th class="table1-th">{{ $t('操作') }}</th>
        </thead>

        <tbody>
          <tr
            v-for="itemInfo in displayedContractTokenAssetList"
            :key="itemInfo.id"
          >
            <td>
              {{ itemInfo.coinCode }}
            </td>
            <td>
              {{ isHideAssetsData ? itemInfo.amountUsable : '******' }}
            </td>
            <td>
              {{ isHideAssetsData ? itemInfo.amountFrozen : '******' }}
            </td>
            <td>
              {{ itemInfo | contractTokenStatFilter(isHideAssetsData) }}
            </td>
            <td>
              <el-button
                type="text"
                @click="$router.push(`/transfer/${itemInfo.coinCode}`)"
              >
                {{ $t('划转') }}
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import {
  ajax_getMyAssetsInfo,
  ajax_getMyAssetList,
  fetchAllCoins,
  fetchUserContractAsset,
} from '@/api/assets'
import {
  SET_HIDE_ASSETS_DATA,
  SET_HIDE_ZERO_BALANCE,
} from '@/store/mutation-types'
import { mapState } from 'vuex'
import { Big } from 'big.js'

export default {
  name: 'MyAssets',
  filters: {
    contractTokenStatFilter({ amountUsable, amountFrozen }, isHideAssetsData) {
      if (!isHideAssetsData) return '******'
      return Big(amountUsable).plus(amountFrozen).toString()
    },
  },
  data() {
    return {
      currentTab: 'tab1',
      allAsset: '--',
      allAssetUSD: '',
      tokenAsset: '--',
      tokenAssetUSD: '',
      contractAsset: '--',
      contractAssetUSD: '',
      coinsTokenAssetList: [], // 币币代币资产列表
      contractTokenAssetList: [], // 合约代币资产列表
      coinConfig: {},
      eyesOpen: require('@/assets/images/close_eyes.png'),
      eyesClose: require('@/assets/images/open_eyes.png'),
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapState({
      isHideAssetsData: (state) => state.personal.isHideAssetsData,
      isHideZeroBalance: (state) => state.personal.isHideZeroBalance,
    }),
    displayedCoinsTokenAssetList() {
      if (this.isHideZeroBalance) {
        return this.coinsTokenAssetList.filter(
          (item) => !!(Number(item.amountUsable) + Number(item.amountFrozen))
        )
      } else {
        return this.coinsTokenAssetList
      }
    },
    displayedContractTokenAssetList() {
      if (this.isHideZeroBalance) {
        return this.contractTokenAssetList.filter(
          (item) => !!(Number(item.amountUsable) + Number(item.amountFrozen))
        )
      } else {
        return this.contractTokenAssetList
      }
    },
  },
  mounted() {
    this.getMyAssetInfo()
    this.getMyAssetList()
    this.getUserContractTokenAssetList()
  },
  methods: {
    handleAction(routeName, coin) {
      /**
       *  认证flag：充币需要kyc1认证，提币需要设置资金密码&kyc2认证
       */
      let needCertify
      // 充币
      if (routeName === 'recharge') {
        needCertify = this.userInfo.c1Status !== 'Yes'
      }
      // 提币
      if (routeName === 'mentionmoney') {
        needCertify = this.userInfo.c2Status !== 'Yes' || !this.userInfo.isTrade
      }
      if (needCertify) {
        this.$Modal.confirm({
          title: this.$t('未完成必要的认证'),
          okText: this.$t('去认证'),
          cancelText: this.$t('取消'),
          onOk: () => {
            this.$router.push({ path: `/notcertified/${routeName}` })
          },
        })
        return
      }

      if (!coin) {
        this.$router.push({ name: routeName })
        return
      }

      if (routeName === 'recharge') {
        this.goToRecharge(coin)
        return
      }
      if (routeName === 'mentionmoney') {
        this.goToWithdraw(coin)
        return
      }
    },
    goToRecharge({ coinId, coinName, amountUsable }) {
      coinName = coinName.toUpperCase()
      if (
        this.coinConfig[coinId] &&
        this.coinConfig[coinId].isRecharge === 'S'
      ) {
        this.$router.push({ name: 'recharge', query: { coinName } })
      } else {
        this.$Message.warning(this.$t('暂不支持充值', { token: coinName }))
      }
    },
    goToWithdraw({ coinId, coinName, amountUsable }) {
      if (
        this.coinConfig[coinId] &&
        this.coinConfig[coinId].isWithdraw === 'S'
      ) {
        if (+amountUsable) {
          this.$router.push({ name: 'mentionmoney', query: { coinId } })
        } else {
          this.$Message.warning(
            this.$t('可用不足', { token: coinName.toUpperCase() })
          )
        }
      } else {
        this.$Message.warning(
          this.$t('暂不支持提取', { token: coinName.toUpperCase() })
        )
      }
    },
    jumpToName(path, params) {
      this.$router.push({ name: path, params: params })
    },
    showHideAssets() {
      this.$store.commit(
        `personal/${SET_HIDE_ASSETS_DATA}`,
        !this.isHideAssetsData
      )
    },
    handleReverseZero() {
      this.$store.commit(
        `personal/${SET_HIDE_ZERO_BALANCE}`,
        !this.isHideZeroBalance
      )
    },
    async getMyAssetInfo() {
      const { btc, usd, actuals, contract } = await ajax_getMyAssetsInfo()
      this.allAsset = btc
      this.allAssetUSD = usd

      this.tokenAsset = actuals.btc
      this.tokenAssetUSD = actuals.usd
      this.contractAsset = contract.btc
      this.contractAssetUSD = contract.usd
    },
    async getCoinConfig() {
      const data = await fetchAllCoins()

      this.coinConfig = data.reduce((calc, item) => {
        calc[item.id] = item
        return calc
      }, {})
    },
    async getMyAssetList() {
      await this.getCoinConfig()
      const { item } = await ajax_getMyAssetList({
        start: 0,
        offset: 9999,
      })
      this.coinsTokenAssetList = item
    },
    async getUserContractTokenAssetList() {
      this.contractTokenAssetList = await fetchUserContractAsset()
    },
  },
}
</script>
<style scoped lang="less">
.top_bg {
  height: 200px;
  background-color: rgba(19, 22, 37, 1);
}
::v-deep .ivu-tabs-nav .ivu-tabs-tab:hover {
  color: #1c1b1b;
}
.content_box {
  .title_content {
    margin-top: -140px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    p {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: #ffffff;
      line-height: 33px;
    }
    span {
      margin-left: 20px;
      font-size: 16px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
    }
  }
  .asset_total {
    margin-top: 30px;
    padding: 20px 40px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    .asset_tips {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, 'PingFang SC';
      font-weight: 400;
      color: #333333;
      line-height: 17px;
    }
    .num_action {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .assets_num {
        height: 45px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, 'PingFang SC';
        font-weight: 600;
        color: #333333;
        line-height: 45px;
        .unit {
          margin-left: 10px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, 'PingFang SC';
          font-weight: 600;
          color: #333333;
          line-height: 22px;
        }
        .show_hide_assets {
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .assets_action {
        button {
          height: 40px;
          padding: 0 24px;
          font-size: 16px;
          color: #1c1b1b;
          &.recharge-btn {
            margin: 0 20px;
            color: #fff;
          }
        }
      }
    }
    .hide_little_coin {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      div {
        width: 14px;
        height: 14px;
        border-radius: 2px;
        border: 1px solid #333333;
        display: flex;
        align-items: center;
        .ok_img {
          font-size: 12px;
        }
      }
      p {
        margin-left: 10px;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular, 'PingFang SC';
        font-weight: 400;
        color: #333333;
        line-height: 17px;
      }
    }
  }
}
.tab-container {
  margin-top: 28px;
  .tab-box {
    padding-left: 20px;
    &-title {
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
    }
    &-btc {
      height: 45px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, 'PingFang SC';
      font-weight: 600;
      color: #333333;
      line-height: 45px;
    }
    &-cny {
      color: #333333;
      line-height: 22px;
    }
  }
  ::v-deep .ivu-tabs-nav {
    .ivu-tabs-ink-bar {
      background-color: #c02e21;
    }
    .ivu-tabs-tab-active {
      color: #1c1b1b;
    }
  }
}
table {
  .table-base(@w: 100%);
  margin-top: 28px;
  margin-bottom: 130px;
  thead {
    height: 28px;
    background-color: rgba(248, 248, 248, 1);
    th {
      text-align: left;
      &.table1-th {
        width: calc(100% / 6);
      }
      &.table2-th {
        width: 25%;
      }
      &:first-child {
        padding-left: 20px;
      }
    }
  }
  tbody {
    tr {
      &:hover {
        background-color: rgb(248, 248, 248);
      }
      td {
        text-align: left !important;
        &:first-child {
          padding-left: 20px;
        }
      }
    }
  }
}
</style>
